module.exports = __webpack_public_path__ + "media/images/comparison_table-9d82ddff33232a3b39c3f65628ebf2fb.png";